import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=415c6082&"
import script from "./EditForm.vue?vue&type=script&lang=ts&"
export * from "./EditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports